import React, { useEffect,useCallback } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
import MomentsComponent from '../Organism/MomentsComponent';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import { loginRequest } from '../../authConfig';

const { Content } = Layout;

const Moments: React.FC = () => {
  const location = useLocation();
  const [anniversaryData, setAnniversaryData] = React.useState(location.state?.anniversaryData);
  const [userId, setUserId] = React.useState<string | null>(null);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (anniversaryData) {
      console.log('Received Anniversary Data:', anniversaryData);
    } else {
      console.warn('No anniversary data received.');
    }
  }, [anniversaryData]);

  useEffect(() => {
    if (userId) {
      checkUserRoleForAnniversary();
    }
  }, [userId]);
 
  useEffect(() => {
    const userId = localStorage.getItem('UserId');
    setUserId(userId);
  }, []);

    const fetchToken = useCallback(async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      }, [instance, accounts]);

      const checkUserRoleForAnniversary = useCallback(async () => {
        if (!userId) return;
    
        try {
          const token = await fetchToken();
          const baseURL = process.env.REACT_APP_API_URL;
          const response = await axios.get(`${baseURL}/api/WorkAnniversaryMilestoneService/CheckUserRoleForAnniversary/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
         
          if (response.status === 200) {
            if(!response.data) {
              return;
            }
  
            const { roles, peerAnniversaries, selfAnniversary } = response.data;
  
            // Check if roles include "Peer" or "Self"
            if (roles.includes('Peer') || roles.includes('Self')) {
              setAnniversaryData({ peerAnniversaries, selfAnniversary });
            }
          }
        } catch (error) {
          console.error('Error checking user role for anniversary:', error);
        }
      }, [userId]);

  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <AppHeaderHomePageTemplate />
      <Content>
        {anniversaryData ? (
          <MomentsComponent
            peerAnniversaries={anniversaryData.peerAnniversaries}
            selfAnniversary={anniversaryData.selfAnniversary}
          />
        ) : (
          <p>No anniversary data available to display.</p>
        )}
      </Content>
    </Layout>
  );
};

export default Moments;